// Pharmascience — child JS entry.
//
// SCSS imports first (compiled as a side-effect of the import). Bootstrap
// and the parent's main.js are already enqueued separately by the child's
// functions.php — do NOT re-import them here.

import '../scss/child.scss';
import { initQuizTransitions } from './modules/quiz-transitions.js';
import { initStickyHeader } from './modules/sticky-header.js';
import { initMobileDrawer } from './modules/mobile-drawer.js';
import { initQuizResultReview } from './modules/quiz-result-review.js';
import { initQuizResultActions } from './modules/quiz-result-actions.js';
import { initQuizAutostart } from './modules/quiz-autostart.js';
import { initReadingProgress } from './modules/reading-progress.js';
import { initTopicToolbar } from './modules/topic-toolbar.js';
import { initMarkCompleteAjax } from './modules/mark-complete-ajax.js';
import { initMotion } from './modules/motion-loader.js';
import { initQuizSubmitRefused } from './modules/quiz-submit-refused.js';

document.addEventListener('DOMContentLoaded', () => {
  initQuizTransitions();
  initStickyHeader();
  initMobileDrawer();
  initQuizResultReview();
  initQuizResultActions();
  initQuizAutostart();
  initReadingProgress();
  initTopicToolbar();
  initMarkCompleteAjax();
  initQuizSubmitRefused();
  initMotion();
});

/**
 * Mid-course language-switch confirmation dialog.
 *
 * Intercepts clicks on language-switcher links tagged with
 * data-bnrmp-lang-switch (only present on course content when the operator
 * has enabled the switcher there). Shows an accessible modal explaining the
 * other language is a separate track, then navigates on confirm. Copy is
 * supplied per-link via data-dialog-* attributes (translated server-side).
 */
( function () {
	'use strict';

	function buildModal( payload, href ) {
		var overlay = document.createElement( 'div' );
		overlay.className = 'bnrmp-langdialog-overlay';

		var modal = document.createElement( 'div' );
		modal.className = 'bnrmp-langdialog';
		modal.setAttribute( 'role', 'dialog' );
		modal.setAttribute( 'aria-modal', 'true' );
		modal.setAttribute( 'aria-labelledby', 'bnrmp-langdialog-title' );

		var title = document.createElement( 'h2' );
		title.className = 'bnrmp-langdialog__title';
		title.id = 'bnrmp-langdialog-title';
		title.textContent = payload.title;

		var body = document.createElement( 'p' );
		body.className = 'bnrmp-langdialog__body';
		body.textContent = payload.body;

		var actions = document.createElement( 'div' );
		actions.className = 'bnrmp-langdialog__actions';

		var cancel = document.createElement( 'button' );
		cancel.type = 'button';
		cancel.className = 'bnrmp-langdialog__btn bnrmp-langdialog__btn--cancel';
		cancel.textContent = payload.cancel;

		var confirm = document.createElement( 'button' );
		confirm.type = 'button';
		confirm.className = 'bnrmp-langdialog__btn bnrmp-langdialog__btn--confirm';
		confirm.textContent = payload.confirm;

		actions.appendChild( cancel );
		actions.appendChild( confirm );
		modal.appendChild( title );
		modal.appendChild( body );
		modal.appendChild( actions );
		overlay.appendChild( modal );
		document.body.appendChild( overlay );

		var lastFocused = document.activeElement;

		function close() {
			document.removeEventListener( 'keydown', onKeydown, true );
			overlay.parentNode && overlay.parentNode.removeChild( overlay );
			if ( lastFocused && typeof lastFocused.focus === 'function' ) {
				lastFocused.focus();
			}
		}

		function onKeydown( e ) {
			if ( e.key === 'Escape' ) {
				e.preventDefault();
				close();
				return;
			}
			if ( e.key === 'Tab' ) {
				var focusables = [ cancel, confirm ];
				var idx = focusables.indexOf( document.activeElement );
				if ( e.shiftKey ) {
					e.preventDefault();
					focusables[ ( idx <= 0 ? focusables.length : idx ) - 1 ].focus();
				} else {
					e.preventDefault();
					focusables[ ( idx + 1 ) % focusables.length ].focus();
				}
			}
		}

		overlay.addEventListener( 'click', function ( e ) {
			if ( e.target === overlay ) {
				close();
			}
		} );
		cancel.addEventListener( 'click', close );
		confirm.addEventListener( 'click', function () {
			window.location.href = href;
		} );
		document.addEventListener( 'keydown', onKeydown, true );

		confirm.focus();
	}

	document.addEventListener( 'click', function ( e ) {
		var link = e.target.closest && e.target.closest( 'a[data-bnrmp-lang-switch]' );
		if ( ! link ) {
			return;
		}
		e.preventDefault();
		buildModal(
			{
				title: link.getAttribute( 'data-dialog-title' ) || '',
				body: link.getAttribute( 'data-dialog-body' ) || '',
				confirm: link.getAttribute( 'data-dialog-confirm' ) || 'OK',
				cancel: link.getAttribute( 'data-dialog-cancel' ) || 'Cancel'
			},
			link.href
		);
	}, false );
} )();

/**
 * Header account menu — close the <details.bnrmp-usermenu> dropdown on an
 * outside click or Escape (native <details> stays open otherwise).
 */
( function () {
	'use strict';
	function closeAll( except ) {
		document.querySelectorAll( 'details.bnrmp-usermenu[open]' ).forEach( function ( d ) {
			if ( d !== except ) { d.removeAttribute( 'open' ); }
		} );
	}
	document.addEventListener( 'click', function ( e ) {
		var menu = e.target.closest ? e.target.closest( 'details.bnrmp-usermenu' ) : null;
		closeAll( menu );
	} );
	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' ) { closeAll( null ); }
	} );
} )();
